const o = "_wrapper_1owxz_1", n = "_selected_1owxz_16", t = "_name_1owxz_19", e = "_leftColumn_1owxz_25", _ = "_logoWrapper_1owxz_28", c = "_infoRow_1owxz_34", s = "_text_1owxz_42", r = "_rightColumn_1owxz_46", a = "_distance_1owxz_52", l = "_chargingIcon_1owxz_55", w = {
  wrapper: o,
  selected: n,
  name: t,
  leftColumn: e,
  logoWrapper: _,
  infoRow: c,
  text: s,
  rightColumn: r,
  distance: a,
  chargingIcon: l
};
export {
  l as chargingIcon,
  w as default,
  a as distance,
  c as infoRow,
  e as leftColumn,
  _ as logoWrapper,
  t as name,
  r as rightColumn,
  n as selected,
  s as text,
  o as wrapper
};
